(() => {
  const SECTION_SUFFIX = '__dod_featured_gear';
  const VISIBLE_COUNT = 8;

  function shuffle(items) {
    for (let i = items.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
    return items;
  }

  function randomizeSection(root = document) {
    const section = root.querySelector?.(`[id$="${SECTION_SUFFIX}"]`) ||
      (root.matches?.(`[id$="${SECTION_SUFFIX}"]`) ? root : null);
    if (!section || section.dataset.dodRandomized === 'true') return;

    const grid = section.querySelector('.product-grid');
    if (!grid) return;

    const cards = Array.from(grid.children).filter((item) =>
      item.classList.contains('grid__item')
    );
    if (cards.length < 2) return;

    shuffle(cards).forEach((card, index) => {
      card.hidden = index >= VISIBLE_COUNT;
      grid.appendChild(card);
    });

    section.dataset.dodRandomized = 'true';
  }

  function initialize() {
    randomizeSection(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) {
      event.target.dataset.dodRandomized = 'false';
      randomizeSection(event.target);
    }
  });
})();
